import axios from "axios";
import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";


const ContactFormCmp = ({ serviceName }) => {


    // console.log(serviceName, 'serviceName')

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        // location: "",
        serviceName: serviceName,
        message: "",
    });


    const [loading, setLoading] = useState(false);

    // Handle Input Change
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Submit Form
    const submitMessage = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}services`, // 👈 endpoint
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            setFormData({
                name: "",
                email: "",
                mobile: "",
                // location: "",
                serviceName: "Architecture Planning",
                message: "",
            });

            toast.success("Message sent successfully");

        } catch (error) {
            console.error("Error:", error);
            const msg = error?.response?.data?.message || error?.message || "Failed to send message";
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* <div className='contactus-section2Right'> */}
                <div className="col-md-12">
                    <form onSubmit={submitMessage}>
                        <div className="row">
                            <div className="col-md-12">
                                <p className="input-inp-head">Full Name *</p>

                                <input
                                    type="text"
                                    name="name"   // ✅ FIXED
                                    placeholder="Full Name"
                                    required
                                    className="input-inp"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </div>

                        </div>
                        <div className="row mt-1">
                            <div className="col-md-6">
                                <p className="input-inp-head">Phone Number *</p>
                                <input
                                    type="tel"
                                    name="mobile"   // ✅ FIXED
                                    placeholder="Phone Number"
                                    required
                                    className="input-inp"
                                    value={formData.mobile}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-6">
                                <p className="input-inp-head">Email Address</p>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email Address"
                                    // required
                                    className="input-inp"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <p className="input-inp-head">Address *</p>
                                <textarea
                                    name="message"
                                    placeholder="Please enter your Address"
                                    required
                                    rows="8"
                                    className="input-inp input-inp2"
                                    value={formData.message}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="text-center">
                            <button type="submit" className="home-section5box-bt" disabled={loading}>
                                <p className="home-section5-btHead">{loading ? "Sending..." : "Send Message"}</p>
                            </button>
                        </div>
                    </form>
                </div>
            {/* </div> */}
        </>
    )
}

export default ContactFormCmp;